import AppLoadingButton from "@/components/mui/LoadingButton";
import RouteConstant from "@/constant/RouteConstant";
import {Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classes from "../css/index.module.less";

export default function AMLStatusBody() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useSelector(state => state.user);

  const _toAmlForm = () => {
    navigate(RouteConstant.KYC_AML);
  }

  if (!user) return null;
  if (!user.kycAmlReject) return null;

  if (user.kycAmlDeclareSubmit == true) {
    return <Box className={classes['kyc-page-info']}>
      <div className={'text-secondary'}>{t('form_submitted_will_review_asap_new')}</div>
    </Box>
  }

  if (user.kycAmlReject == 2) {
    return <Box className={classes['kyc-page-info']}>
      {t('kyc_aml_final_reject')}
    </Box>
  }

  return (
    <Box>
      <Box className={classes['kyc-page-info']}>
        <div className={'h5'}>{t('additional_info_request')}</div>
        <div className={'text-secondary'}>{t('not_able_to_submit_identity')}</div>
        <div className={'text-secondary'}>{t('aml_review_failed')}</div>
        <div className={'text-secondary'}>{t('aml_declaration_prompt')}</div>
      </Box>
      <Box className={"fixed-button"}>
        <AppLoadingButton fullWidth variant="contained" size="large" onClick={_toAmlForm}>
          {t('continue_key')}
        </AppLoadingButton>
      </Box>
    </Box>
  );
}
